import { useMutation } from "@apollo/client";
import { USER_EXPORT_INSTR_ATTACHMENT_VIEWS } from "graphql/mutation/user-gql";
import { successNotification, errorNotification } from "components/request-result";
import { saveAs } from "file-saver";


const useMutationUserReport = () => {

    function getFileNameFromUrl(url) {
        const value = url.split('/');
        return value[ value.length - 1 ];
    }

    const [ _setUserReport, { loading } ] = useMutation(USER_EXPORT_INSTR_ATTACHMENT_VIEWS,
        {
            update(cache, { data }) {

                const {
                    usersExportInstructionAttachmentViews: {
                        label,
                        message,
                        file
                    }
                } = data;

                successNotification({
                    title: label,
                    description: message
                })


                saveAs(file, getFileNameFromUrl(file));
            },


            onError(error) {
                errorNotification(error);
            },

        }
    );


    return {
        _setUserReport,
        loadingMutationUserReport: loading,
    }
};


export default useMutationUserReport;

